module.exports = __webpack_public_path__ + "img/case-umcc.ad5a2a04.png";